import { Component, OnInit } from '@angular/core';
import { Inplace } from 'primeng/inplace';
import { Router } from '@angular/router';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-rental-products',
  templateUrl: './rental-products.component.html',
  styleUrls: ['./rental-products.component.scss'],
  providers: [MessageService],
})
export class RentalProductsComponent implements OnInit {
  public loading: boolean = false;
  public rentalProducts: any = [];
  public filteredRentalProducts: any = [];
  public categories: any = [];
  public brands: any = [];
  public expandedProduct: any = {};
  public selectedCategoryFilter: any = {};
  public selectedBrandFilter: any = {};
  public isCloneProduct: boolean = false;
  public showRentalProduct: boolean = false;
  public selectedProduct: any = {};
  public maxRentalProducts: number = 0;
  public productLimitReached: boolean = false;
  public hasDemoProducts : boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    public messageService: MessageService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getRentalProducts();
  }

  getRentalProducts() {
    this.loading = true;
    this.rentalsService
      .getRentalProducts(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.rentalProducts = res;
          this.loading = false;
          this.rentalProducts.forEach((x) => {
            x.sizes = x.rentalProducts
              .map((y) => {
                return y.size ? y.size.toUpperCase() : '';
              })
              .filter(
                (v, i, a) =>
                  a
                    .map((y) => {
                      return y;
                    })
                    .indexOf(v) === i,
              );
          });
          this.filterRentalProducts();
          this.setFilters();
          var subscriptionInfo = this.helpersService.getPaymentStatus();
          if (subscriptionInfo && subscriptionInfo.rentalProductsAllowed) {
            var numberRentalProducts = 0;
            this.rentalProducts.map((y: any) => {
              numberRentalProducts += y.rentalProducts.length;
            });
            console.log(numberRentalProducts);
            console.log(subscriptionInfo);
            if (
              numberRentalProducts >= subscriptionInfo.rentalProductsAllowed
            ) {
              this.productLimitReached = true;
            } else {
              this.productLimitReached = false;
            }
          }
          this.hasDemoProducts = this.rentalProducts.some((x) => {
            return x.rentalProducts.some((y) => {
              return y.isDemo;
            });
          });
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  setFilters() {
    if (this.selectedCategoryFilter.categoryID) {
      this.brands = this.filteredRentalProducts
        .map((x) => {
          return { brand: x.brand };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.brand;
              })
              .indexOf(v.brand) === i,
        );
    } else if (this.selectedBrandFilter.brand) {
      this.categories = this.filteredRentalProducts
        .map((x) => {
          return { categoryID: x.categoryID, categoryName: x.categoryName };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.categoryID;
              })
              .indexOf(v.categoryID) === i,
        );
    } else {
      this.brands = this.filteredRentalProducts
        .map((x) => {
          return { brand: x.brand };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.brand;
              })
              .indexOf(v.brand) === i,
        );
      this.categories = this.filteredRentalProducts
        .map((x) => {
          return { categoryID: x.categoryID, categoryName: x.categoryName };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.categoryID;
              })
              .indexOf(v.categoryID) === i,
        );
    }
  }

  setSearch(value) {
    console.log(value);
    this.filteredRentalProducts = this.rentalProducts.filter((x) => {
      return (
        x.brand.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.model.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.categoryName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    });
    this.setFilters();
  }

  filterRentalProducts() {
    this.filteredRentalProducts = this.rentalProducts;
    if (this.selectedCategoryFilter.categoryID) {
      this.filteredRentalProducts = this.filteredRentalProducts.filter((x) => {
        return x.categoryID === this.selectedCategoryFilter.categoryID;
      });
    }
    if (this.selectedBrandFilter.brand) {
      this.filteredRentalProducts = this.filteredRentalProducts.filter((x) => {
        return x.brand === this.selectedBrandFilter.brand;
      });
    }
  }

  selectCategoryFilter(value) {
    if (value.categoryID === this.selectedCategoryFilter.categoryID) {
      this.selectedCategoryFilter = {};
    } else {
      this.selectedCategoryFilter = value;
    }
    this.filterRentalProducts();
    this.setFilters();
  }

  selectBrandFilter(value) {
    if (value.brand === this.selectedBrandFilter.brand) {
      this.selectedBrandFilter = {};
    } else {
      this.selectedBrandFilter = value;
    }
    this.filterRentalProducts();
    this.setFilters();
  }

  expandProduct(product) {
    if (
      product.brand == this.expandedProduct.brand &&
      product.model == this.expandedProduct.model &&
      product.yearModel == this.expandedProduct.yearModel &&
      product.categoryID == this.expandedProduct.categoryID
    ) {
      this.expandedProduct = {};
    } else {
      this.expandedProduct = product;
    }
  }

  editProduct(product) {
    this.selectedProduct = product;
    this.isCloneProduct = false;
    this.showRentalProduct = true;
  }

  cloneProduct(product) {
    this.selectedProduct = product;
    this.isCloneProduct = true;
    this.showRentalProduct = true;
  }

  hashCode(str) {
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  }

  closeRentalProduct() {
    this.showRentalProduct = false;
  }

  addNewRentalProduct() {
    this.selectedProduct = {};
    this.isCloneProduct = false;
    this.showRentalProduct = true;
  }

  updateRecord(product, object: Inplace) {
    this.rentalsService
      .updateRentalProductInline(this.helpersService.getPartnerId(), product)
      .subscribe(
        (res) => {
          object.deactivate(null);
        },
        (err) => {},
      );
  }

  isProductComplete(product) {
    if (
      product.rentalProducts.filter((x: any) => {
        return (
          x.priceGroupID === null ||
          x.priceGroupID === undefined ||
          x.priceGroupID === 0
        );
      }).length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  navigateImportProducts() {
    this.router.navigate(['/store/rentals/products-import']);
  }
}
